import { Check, ChevronDown } from "lucide-react";

const StepButtons = ({ steps, currentStep, onStepChange }) => steps.map((step) => {
      const isActive = currentStep === step.id;
      const isCompleted = currentStep > step.id;
      return (
        <button
          key={step.id}
          type="button"
          onClick={() => onStepChange(step.id)}
          aria-current={isActive ? "step" : undefined}
          className={`flex shrink-0 items-center gap-3 rounded-xl px-3 py-2.5 text-left transition-colors lg:w-full ${
            isActive
              ? "bg-[#16877c] text-white shadow-sm"
              : isCompleted
                ? "bg-[#e9f5db] text-[#315b36]"
                : "text-[#66736f] hover:bg-[#edf2ed]"
          }`}
        >
          <span className={`flex h-6 w-6 items-center justify-center rounded-full text-xs ${
            isActive ? "bg-white text-[#116d64]" : isCompleted ? "bg-[#9bc53d] text-[#101a19]" : "bg-[#e1e7e1] text-[#66736f]"
          }`}>
            {isCompleted ? <Check className="h-3 w-3" /> : step.id}
          </span>
          <span className="truncate text-sm font-medium">{step.name}</span>
        </button>
      );
    });

const ProgramStepNavigation = ({ steps, currentStep, onStepChange }) => {
  const activeIndex = Math.max(0, steps.findIndex((step) => step.id === currentStep));
  const activeStep = steps[activeIndex] || steps[0];

  return (
    <nav aria-label="Program creation steps">
      <details className="group rounded-xl border border-[#d8dfd9] bg-white lg:hidden">
        <summary className="flex min-h-12 cursor-pointer list-none items-center justify-between gap-3 rounded-xl px-4 py-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#16877c] focus-visible:ring-offset-2 [&::-webkit-details-marker]:hidden">
          <span className="min-w-0">
            <span className="block text-xs font-semibold uppercase tracking-[0.12em] text-[#66736f]">Step {activeIndex + 1} of {steps.length}</span>
            <span className="block truncate text-sm font-semibold text-[#101a19]">{activeStep?.name}</span>
          </span>
          <ChevronDown className="h-5 w-5 shrink-0 text-[#66736f] transition-transform group-open:rotate-180" aria-hidden="true" />
        </summary>
        <div className="space-y-1 border-t border-[#e1e7e1] p-2">
          <StepButtons steps={steps} currentStep={currentStep} onStepChange={onStepChange} />
        </div>
      </details>
      <div className="hidden space-y-1 lg:block">
        <StepButtons steps={steps} currentStep={currentStep} onStepChange={onStepChange} />
      </div>
    </nav>
  );
};

export default ProgramStepNavigation;
